import React from "react";
import Services from "../components/Services/Services";

const ServicePage = () => {
  return (
    <>
      <Services />
    </>
  );
};

export default ServicePage;
